<template>
  <div class="">
    <!-- <b-row>
      <b-col md="9">
        <div
          v-if="transactions"
          class="mb-3 mt-3"
          style="display: flex; justify-content: space-between"
        >
          <h3>{{ transactions.length }} transactions</h3>
        </div>
      </b-col>
    </b-row> -->
    <b-row>
      <b-col md="6">
        <b-card no-body>
          <b-card-header>
            <span v-label-key="'TIME_PERIOD'">Time Period</span>
          </b-card-header>
          <b-card-body>
            <date-range-selector v-model="selectedRange" hide-refresh />
            <b-form-group :label="getLabel('REPORTS_CUT_TYPES')">
              <b-form-select v-model="cutType">
                <b-form-select-option value="ALL_CUTS">
                  <span v-label-key="'REPORTS_CUT_TYPES_ALL'">All Cuts</span>
                </b-form-select-option>
                <b-form-select-option value="STANDARD_CUTS">
                  <span v-label-key="'REPORTS_CUT_TYPES_STANDARD'"
                    >Standard Cuts Only</span
                  >
                </b-form-select-option>
                <b-form-select-option value="WARRANTY_CUTS">
                  <span v-label-key="'REPORTS_CUT_TYPES_WARRANTY'"
                    >Warranty Cuts Only</span
                  >
                </b-form-select-option>
              </b-form-select>
            </b-form-group>
            <!-- <b-button
              size="lg"
              variant="outline-primary"
              block
              @click="fetchThenDownload()"
            >
              <span class="glyphicon glyphicon-search" aria-hidden="true" />
              <i class="fa fa-download" /> Download CSV
            </b-button> -->
            <b-button
              size="lg"
              variant="outline-success"
              block
              @click="fetchThenDownload()"
              :disabled="loading"
            >
              <span class="glyphicon glyphicon-search" aria-hidden="true" />
              <b-spinner
                v-if="loading"
                style="border-width: 2px; height:20px; width:20px;"
              />
              <i v-else class="fa fa-download" />
              &nbsp;
              <span v-label-key="'DOWNLOAD_EXCEL'">Download Excel</span>
            </b-button>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col md="6" />
    </b-row>
  </div>
</template>
<script>
import $api from '@/services/api';
// import $csv from '@/services/csv';
import $excel from '@/services/excel';
import DateRangeSelector from '@/components/DateRangeSelector';
import { mapGetters } from 'vuex';

export default {
  name: 'TransactionList',
  components: {
    DateRangeSelector,
  },
  /* eslint-disable-next-line vue/prop-name-casing, vue/require-prop-types */
  props: ['distributor_id', 'subdistributor_id', 'chain_id', 'store_id'],
  computed: {
    ...mapGetters('translations', {
      getLabel: 'getLabel',
    }),
  },
  data() {
    return {
      transactions: null,
      loading: false,
      cutType: 'ALL_CUTS',
      selectedRange: null,
    };
  },
  methods: {
    update() {
      return !!this.transactions;
    },
    async fetchThenDownload() {
      console.log('Fetching...');
      this.loading = true;
      await this.loadTransactions();
      this.loading = false;
      this.downloadFile();
    },
    loadTransactions() {
      this.loading = true;
      const payload = {
        distributor_id: this.distributor_id,
        subdistributor_id: this.subdistributor_id,
        chain_id: this.chain_id,
        store_id: this.store_id,
      };
      payload._start = this.selectedRange.start; // eslint-disable-line no-underscore-dangle
      payload._end = this.selectedRange.end; // eslint-disable-line no-underscore-dangle
      payload.cuttype = this.cutType;
      return $api
        .get('/v1/dashboard/transactions', payload)
        .then((transactions) => {
          this.transactions = transactions;
          this.loading = false;
        })
        .catch((e) => {
          this.loading = false;
          alert(`Error: ${e}`);
        });
    },
    downloadFile() {
      const headerKeys = [
        'ID',
        'STORE_ID',
        'STORE_NAME',
        'STORE_SETTING_SET_CHAIN_GROUP',
        'CHAIN_ID',
        'CHAIN_NAME',
        'SUBDISTRIBUTOR_ID',
        'SUBDISTRIBUTOR_NAME',
        'DISTRIBUTOR_ID',
        'DISTRIBUTOR_NAME',
        'LOCATION_COUNTRY',
        'WARRANTY_FIELD_DEVICE_BRAND',
        'WARRANTY_FIELD_DEVICE_MODEL',
        'TEMPLATE',
        'WARRANTY_FIELD_FILMTYPE_NAME',
        'WARRANTY_FIELD_FILMTYPE_DESCRIPTION',
        'MACHINE_NAME',
        'MACHINE_CONNECTION',
        'PUBLIC_STATUS',
        'STAFF_ID',
        'STAFF_NAME',
        'WARRANTY_FIELD_FILMCODE_ID',
        'WARRANTY_FIELD_FUNDING',
        'CREATED',
        'CUT_WIDTH',
        'CUT_HEIGHT',
        'ORDER_ID',
        'TRANSACTION_FOUR_SEASONS_VOUCHER_ID',
        'ISSUED_WARRANTY_ID',
        'WARRANTY_ID',
        'WARRANTY_CLAIM_ID',
        'JIRA_TASK_ID',
        'FAILURE_REASON',
        'FAILURE_REASON_USER_COMPLAINT',
        'FAILURE_REASON_PHOTO',
        'INSTALL_ID_FULL',
        'OPERATING_SYSTEM',
        'INSTALLS_HARD_VERSION',
        'INSTALLS_SOFT_VERSION',
        'USER_EMAILS',
        'INSTALLS_USERAGENT',
      ];
      const headers = headerKeys.map(this.getLabel);
      const fields = [
        'id',
        'store_id',
        'store_name',
        'chain_group',
        'chain_id',
        'chain_name',
        'subdistributor_id',
        'subdistributor_name',
        'distributor_id',
        'distributor_name',
        'country',
        'manufacturer_name',
        'device_name',
        'template_name_local',
        'filmtype_name_local',
        'filmtype_description_local',
        'machine_name',
        'machine_connection',
        'public_status',
        'staff_id',
        'staff_name',
        'filmcode_id',
        'funding',
        'created',
        'cut_width',
        'cut_height',
        'order_id',
        'fsvoucher_id',
        'issued_warranty_id',
        'warranty_id',
        'warrantyclaim_id',
        'jira_task_id',
        'failure_reason',
        'user_complaint',
        'failure_photo',
        'install_id',
        'operating_system',
        'hard_version',
        'soft_version',
        'user_emails',
        'user_agent',
      ];

      // Only show chain_groups if at least 1 store is using it
      const showChainGroups = this.transactions.some(
        (transaction) => transaction.chain_group,
      );
      if (!showChainGroups) fields.splice(fields.indexOf('chain_group'), 1);
      if (!showChainGroups) {
        headers.splice(headerKeys.indexOf('STORE_SETTING_SET_CHAIN_GROUP'), 1);
      }

      // Hide mycut and teneth words for customer sensitivity reasons
      const machineConnectionReplace = {
        'mycut-serial': 'mc-serial',
        'teneth-serial': 'tn-serial',
      };
      const output = this.transactions
        .sort((a, b) => a.id - b.id)
        .map((item) => {
          const transaction = {
            ...item,
            failure_photo:
              item.failure_photo == null || !item.failure_photo
                ? null
                : `https://cdn.gokaizen.com/${item.failure_photo}`,
            operating_system: item.operating_system.family,
            user_emails:
              item.user_emails == null ? null : item.user_emails.join(', '),
          };
          if (
            item.machine_connection &&
            machineConnectionReplace[item.machine_connection]
          ) {
            transaction.machine_connection =
              machineConnectionReplace[item.machine_connection];
          }
          return transaction;
        });
      // $csv.export(output, fields, 'transactions.csv');
      $excel.export(output, fields, 'transactions', headers);
    },

    scrollTop() {
      const el = document.getElementById('transaction-table').offsetTop + 130;
      window.scrollTo({ top: el, behavior: 'smooth' });
    },
  },
};
</script>

<style scoped>
.custom-table /deep/ thead th {
  min-width: 110px;
}
</style>
